// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--rsBzW","image":"da51a739f7--image--nzo81","description":"da51a739f7--description--NKQ51"};